export default __webpack_public_path__ + "static/media/crisp3.2c2a22c1.png";